<template>
  <!-- 第三屏，跨端生态 -->
  <div id="eye-care-screen" class="eye-care-screen" data-sidebar="5">
    <div class="eye-care-top" data-position="0" data-name="悦目护眼">
      <PlusImage class="eye-bg" :src="eyebgImg" alt="" />
      <div class="eye-title ffm600" v-animate>用心呵护<br v-if="isMobile"/>你的眼眸</div>
      <!-- 与ios互联 -->
      <div class="eye-ios" v-animate>
        <div class="care-wrap">
          <div class="care-title ffm500">悦目护眼</div>
          <div class="care-subtitle ffm600">看多久都舒服</div>
          
          <div v-if="isPC" class="care-desc ffm400">
            全新悦目护眼，聚合护眼模式、AI舒眠模式等护眼能力，<br />同时，优化后的护眼模式色温对干眼更友好，久看不累眼。
          </div>
          <div v-else class="care-desc ffm400">
            全新悦目护眼，聚合护眼模式、AI舒眠模式等护眼能力，同时，优化后的护眼模式色温对干眼更友好，久看不累眼。
          </div>
        </div>
      </div>
    </div>

    <div class="eye-other" data-position="1" data-name="AI舒眠模式" v-animate>
      <div class="eye-home">
        <div class="home-title z-index2 ffm500">AI舒眠模式</div>
        <div class="home-subtitle z-index2 ffm600">减少蓝光助好眠</div>
        <div class="home-desc z-index2 ffm400">
          智能学习你的作息，睡前数小时，屏幕自动调节色温，减少蓝光干扰，让你更好入眠。
        </div>
        <div class="home-content z-index2">
          <p class="p1 ffm500">褪黑素分泌影响减少</p>
          <p class="p2 ffm600">25%↓</p>
        </div>
        <PlusImage class="home-img" :src="eyeLeftImg" alt="" />
      </div>
      <div class="eye-home">
        <div class="home-title z-index2 ffm500">晕动视觉辅助</div>
        <div class="home-subtitle z-index2 ffm600">乘车看屏幕更舒适</div>
        <div class="home-desc z-index2 ffm400">
          智能识别车辆运动方向，在屏幕上显示随车移动的提示圆点，缓解因乘车看屏幕导致的晕车感，让路途更舒适。
        </div>
        <video v-if="isPC" class="home-video" ref="shakeVideo" :src="VIDEOS.eyeRight" muted autoplay loop alt=""></video>
        <PlusImage class="home-img" :src="eyeRightImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EYE_CARE } from "@/config/image.js";
import { initExposureTrack } from '@/utils/track.js'
import VIDEOS from "@/config/video";

export default {
  name: "EyeCare",
  data() {
    return {
      EYE_CARE,
      VIDEOS,
    };
  },
  computed: {
    ...mapGetters(['isPC', 'isPad', 'isMobile']),
    eyebgImg() {
      if (this.isPC) {
        return this.EYE_CARE.eyebg
      } else if (this.isPad) {
        return this.EYE_CARE.eyebgPad
      } else {
        return this.EYE_CARE.eyebgH5
      }
    },
    eyeLeftImg() {
      if (this.isPC) {
        return this.EYE_CARE.eyeLeft
      } else if (this.isPad) {
        return this.EYE_CARE.eyeLeftPad
      } else {
        return this.EYE_CARE.eyeLeftH5
      }
    },
    eyeRightImg() {
      if (this.isPC) {
        return this.EYE_CARE.eyeRight
      } else if (this.isPad) {
        return this.EYE_CARE.eyeRightPad
      } else {
        return this.EYE_CARE.eyeRightH5
      }
    },
  },
  mounted() {
    initExposureTrack('.eye-care-screen [data-position]')()
  }
};
</script>

<style lang="scss" scoped>
.eye-care-screen {
  display: flex;
  flex-direction: column;
  background-color: #000000;
  padding-bottom: 120 * $px1920vw + vw;
  position: relative;

  .eye-care-top {
    width: 100%;
    height: 955 * $px1920vw + vw;
    position: relative;
    overflow: hidden;
    .eye-bg {
      width: 100%;
      height: 955 * $px1920vw + vw;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }

    .eye-title {
      width: fit-content;
      margin: 0 auto;
      font-size: 96 * $px1920vw + vw;
      line-height: 115 * $px1920vw + vw;
      text-align: center;
      background: linear-gradient(270deg, #C3EABC 0%, #FFFFFF 98%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      margin-top: 140 * $px1920vw + vw;
      position: relative;
      z-index: 2;
    }

    .eye-ios {
      width: 1200 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;
      border-radius: 24 * $px1920vw + vw;
      position: absolute;
      bottom: 0;
      left: 360 * $px1920vw + vw;
      z-index: 2;

      .care-wrap {
        text-align: left;
        height: 100%;
        padding-left: 48 * $px1920vw + vw;
        padding-top: 209 * $px1920vw + vw;
        position: relative;
        overflow: hidden;

        .care-title {
          font-size: 28 * $px1920vw + vw;
          line-height: 33.6 * $px1920vw + vw;
          color: #FFFFFF;
        }

        .care-subtitle {
          font-size: 40 * $px1920vw + vw;
          line-height: 48 * $px1920vw + vw;
          color: #FFFFFF;
          word-break: keep-all;
          margin-top: 12 * $px1920vw + vw;
        }

        .care-desc {
          width: 480 * $px1920vw + vw;
          margin-top: 36 * $px1920vw + vw;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
        }
        
      }
    }
  }

  .eye-other {
    width: 1200 * $px1920vw + vw;
    display: flex;
    justify-content: space-between;
    margin-top: 24 * $px1920vw + vw;
    margin-left: 360 * $px1920vw + vw;

    .eye-home {
      width: 588 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;
      border-radius: 24 * $px1920vw + vw;
      background: #1E1E1E;
      text-align: left;
      overflow: hidden;
      position: relative;
      padding-top: 48 * $px1920vw + vw;

      .home-img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      .home-video {
        width: 230 * $px1920vw + vw;
        height: auto;
        position: absolute;
        left: 179 * $px1920vw + vw;
        top: 244 * $px1920vw + vw;
        border-radius: 36 * $px1920vw + vw;
      }

      .z-index2 {
        z-index: 2;
        position: relative;
      }

      .home-title {
        font-size: 24 * $px1920vw + vw;
        line-height: 29 * $px1920vw + vw;
        color: #2785FF;
        padding-left: 48 * $px1920vw + vw;
      }

      .home-subtitle {
        font-size: 32 * $px1920vw + vw;
        line-height: 39 * $px1920vw + vw;
        color: #FFFFFF;
        margin-top: 8 * $px1920vw + vw;
        padding-left: 48 * $px1920vw + vw;
      }

      .home-desc {
        width: 504 * $px1920vw + vw;
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 16 * $px1920vw + vw;
        padding-left: 48 * $px1920vw + vw;
        box-sizing: content-box;
      }

      .home-content {
        margin-top: 56 * $px1920vw + vw;
        color: #FFFFFF;
        text-align: center;
        .p1 {
          font-size: 22 * $px1920vw + vw;
          line-height: 29 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
        }
        .p2 {
          font-size: 48 * $px1920vw + vw;
          line-height: 58 * $px1920vw + vw;
        }
      }
    }
  }
}

.isPad {
  .eye-care-screen {
    .eye-care-top {
      height: 576 * $px676vw + vw;
      .eye-bg {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      .eye-mask {
        display: none;
      }

      .eye-title {
        font-size: 42 * $px676vw + vw;
        line-height: 49 * $px676vw + vw;
        margin-top: 66 * $px676vw + vw;
      }

      .eye-ios {
        position: sticky;
        width: 100%;
        height: fit-content;
        background: none;
        backdrop-filter: none;
        margin-top: 238 * $px676vw + vw;

        .care-wrap {
          text-align: left;
          height: 100%;
          padding-left: 83 * $px676vw + vw;
          padding-top: 0;
          position: relative;
          overflow: hidden;

          .care-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            color: #FFFFFF;
          }

          .care-subtitle {
            font-size: 20 * $px676vw + vw;
            line-height: 23 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
          }

          .care-desc {
            width: 226 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }

      .eye-mask {
        width: 100%;
        margin-top: 276 * $px676vw + vw;
        height: 425 * $px676vw + vw;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 11%, rgba(0, 0, 0, 0.16) 45%, #000000 100%);
        position: relative;
        z-index: 2;
      }
    }

    .eye-other {
      width: 596 * $px676vw + vw;
      margin-top: 20 * $px676vw + vw;
      margin-left: 40 * $px676vw + vw;

      .eye-home {
        width: 288 * $px676vw + vw;
        height: 360 * $px676vw + vw;
        border-radius: 16 * $px676vw + vw;
        padding-top: 26 * $px676vw + vw;
        position: relative;

        .home-title {
          font-size: 12 * $px676vw + vw;
          line-height: 14 * $px676vw + vw;
          color: #2785FF;
          padding-left: 22 * $px676vw + vw;
        }

        .home-subtitle {
          font-size: 20 * $px676vw + vw;
          line-height: 23 * $px676vw + vw;
          margin-top: 6 * $px676vw + vw;
          padding-left: 22 * $px676vw + vw;
        }

        .home-desc {
          width: 240 * $px676vw + vw;
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
          margin-top: 12 * $px676vw + vw;
          padding-left: 22 * $px676vw + vw;
        }

        .home-content {
          margin-top: 0;
          color: #FFFFFF;
          text-align: center;
          position: absolute;
          top: 162 * $px676vw + vw;
          left: 96 * $px676vw + vw;
          .p1 {
            font-size: 10.56 * $px676vw + vw;
            line-height: 13 * $px676vw + vw;
            color: rgba(255, 255, 255, 0.8);
          }
          .p2 {
            font-size: 28.16 * $px676vw + vw;
            line-height: 34 * $px676vw + vw;
          }
        }
      }
    }
  }
}

.isMobile {
  .eye-care-screen {
    .eye-care-top {
      height: 507 * $px360vw + vw;
      .eye-bg {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      .eye-mask {
        display: none;
      }
      .eye-title {
        font-size: 42 * $px360vw + vw;
        line-height: normal;
        margin-top: 26 * $px360vw + vw;
      }
      .eye-ios {
        position: sticky;
        width: 100%;
        height: fit-content;
        background: none;
        backdrop-filter: none;
        margin-top: 51 * $px360vw + vw;
        .care-wrap {
          padding-left: 42 * $px360vw + vw;
          padding-top: 0;
          width: 100%;
          .care-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
            margin-top: 0;
          }
          .care-subtitle {
            font-size: 20 * $px360vw + vw;
            line-height: 23 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
          }
          .care-desc {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            color: rgba(255, 255, 255, 0.6);
            width: 276 * $px360vw + vw;
            margin: 12 * $px360vw + vw 0 0 0;
          }
        }
      }
    }
    .eye-other {
      display: inline-block;
      width: 100%;
      margin-top: 0;
      margin-left: 0;
      .eye-home {
        width: 320 * $px360vw + vw;
        height: 360 * $px360vw + vw;
        margin: 0 auto;
        margin-top: 20 * $px360vw + vw;
        padding-top: 28 * $px360vw + vw;
        padding-left: 22 * $px360vw + vw;
        padding-right: 20 * $px360vw + vw;
        border-radius: 10 * $px360vw + vw;
        .home-title {
          font-size: 12 * $px360vw + vw;
          line-height: 14 * $px360vw + vw;
          padding-left: 0;
        }
        .home-subtitle  {
          font-size: 20 * $px360vw + vw;
          line-height: 23 * $px360vw + vw;
          margin-top: 6 * $px360vw + vw;
          padding-left: 0;
        }
        .home-desc {
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          width: 100%;
          margin-top: 12 * $px360vw + vw;
          color: rgba(255, 255, 255, 0.8);
          padding-left: 0;
        }

        .home-content {
          margin-top: 37 * $px360vw + vw;
          color: #FFFFFF;
          text-align: center;
          .p1 {
            font-size: 12 * $px360vw + vw;
            line-height: 17 * $px360vw + vw;
            color: rgba(255, 255, 255, 0.8);
          }
          .p2 {
            font-size: 28 * $px360vw + vw;
            line-height: 34 * $px360vw + vw;
          }
        }
      }
    }
  }
}
</style>